import { ScreenSize } from '@libs/shared-services';
import {
  CHARTING_CONTAINER_HEIGHT,
  Coordinates,
  GUM_INTERMEDIATE_BUMP,
  Jaw,
  TEETH_CONTAINER_PADDING_Y,
  TOOTH_FULL_HEIGHT,
  TOOTH_HEIGHT,
  ToothSide,
} from '@libs/ui-lib';

export const TEETH_TRANSLATE_Y = (
  screenSize: ScreenSize,
): { upper: { buccal: number; lingual: number }; lower: { buccal: number; lingual: number } } => ({
  upper: { buccal: TEETH_CONTAINER_PADDING_Y(screenSize), lingual: TEETH_CONTAINER_PADDING_Y(screenSize) },
  lower: {
    buccal: CHARTING_CONTAINER_HEIGHT(screenSize) - TEETH_CONTAINER_PADDING_Y(screenSize) - TOOTH_FULL_HEIGHT(screenSize),
    lingual: CHARTING_CONTAINER_HEIGHT(screenSize) - TEETH_CONTAINER_PADDING_Y(screenSize) - TOOTH_FULL_HEIGHT(screenSize),
  },
});

export const PERIO_TRANSLATE_Y =
  (screenSize: ScreenSize) =>
  (jaw: Jaw, side: ToothSide, coordinates: Coordinates, measurementsCoordinates: Coordinates, pocketDepth: number): number => {
    const MEASUREMENT_INCREMENTS = 3.5;
    const y = {
      upper: {
        buccal: coordinates.y + measurementsCoordinates.y - pocketDepth * MEASUREMENT_INCREMENTS,
        lingual: coordinates.y + measurementsCoordinates.y - pocketDepth * MEASUREMENT_INCREMENTS,
      },
      lower: {
        lingual:
          coordinates.y +
          measurementsCoordinates.y +
          pocketDepth * MEASUREMENT_INCREMENTS +
          TOOTH_FULL_HEIGHT(screenSize) -
          TOOTH_HEIGHT(screenSize),
        buccal:
          coordinates.y +
          measurementsCoordinates.y +
          pocketDepth * MEASUREMENT_INCREMENTS +
          TOOTH_FULL_HEIGHT(screenSize) -
          TOOTH_HEIGHT(screenSize),
      },
    };
    return y[jaw][side];
  };

export const GUM_INTERMEDIARY_BUMP =
  (screenSize: ScreenSize) =>
  (jaw: Jaw, _: ToothSide): number => {
    return GUM_INTERMEDIATE_BUMP(screenSize) * (jaw === 'upper' ? 1 : -1);
  };
